import * as ng from '@angular/core';
import {Component} from "@angular/core";
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'body',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent implements ng.OnInit {
  title = 'app';

  constructor(private router: Router) {
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
